import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export const useGetAssociationLabelsPrefix = associationDefinitions => {
  var _firstDefinition$toOb;
  if (!associationDefinitions.length) {
    return null;
  }
  const firstDefinition = associationDefinitions[0];
  const objectTypeId = (_firstDefinition$toOb = firstDefinition.toObjectTypeDefinition) === null || _firstDefinition$toOb === void 0 ? void 0 : _firstDefinition$toOb.id;
  if (!objectTypeId) {
    return null;
  }
  const translationKey = `cardAssociatedObjects.chicklet.AssociationChicklet.prefix.${objectTypeId}`;
  if (isValidI18nKey(translationKey)) {
    return I18n.text(translationKey);
  }
  return null;
};